import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=079354bd&scoped=true"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"
import style0 from "./quotation.vue?vue&type=style&index=0&id=079354bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079354bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079354bd')) {
      api.createRecord('079354bd', component.options)
    } else {
      api.reload('079354bd', component.options)
    }
    module.hot.accept("./quotation.vue?vue&type=template&id=079354bd&scoped=true", function () {
      api.rerender('079354bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/generateContract/quotation.vue"
export default component.exports